export const  flightQuestion = [
            {
                id:1,
                question:"چند روز قبل از پرواز، بلیط هواپیما را بخریم؟",
                answer:
                "امکان رزرو بلیط هواپیما از ماه‌ها قبل وجود دارد. اما گاهی اوقات قیمت بلیط هواپیما در روزهای نزدیک به پرواز ارزان‌تر می‌شود. بنابراین در صورتی که شرایطتان اجازه می‌دهد، رزرو آنلاین بلیط هواپیما را به روزهای نزدیک پرواز موکول کنید. البته اگر قصد سفر در ایام پرسفر نظیر تعطیلات را دارید، باید هر چه زودتر رزرو بلیط هواپیما را انجام دهید."
            },
            {
                id:2,
                question:"در هر پرواز، میزان بار مجاز چقدر است؟ ",
                answer:
                "میزان مجاز بار به کلاس پرواز و کلاس نرخی بلیط بستگی دارد. هنگام خرید آنلاین بلیط هواپیما می‌توانید میزان بار مجاز را در اطلاعات بلیط ببینید. طبیعی است که اگر میزان بارتان بیش از حد مجاز باشد، باید جریمه پرداخت کنید."
            }
            ,
            {
                id:3,
                question:"نرخ بلیط هواپیما برای نوزادان و کودکان زیر 12 سال چگونه است؟ ",
                answer:
                "این نرخ به کلاس پرواز و کلاس نرخی بستگی دارد. اما عموما 50 تا 75 درصد قیمت بلیط بزرگسالان است. قیمت بلیط هواپیما برای نوزادان (تا 2 سال) در بیشتر موارد 10 درصد بلیط بزرگسالان است. هنگام تهیه بلیط هواپیما به این نکته توجه داشته باشید."
            }
            ,
            {
                id:4,
                question:"رزرو آنلاین بلیط هواپیما هزینه بیشتری از خرید حضوری دارد؟ ",
                answer:
                "خیر؛ زمانی که از یک سایت معتبر خرید بلیط هواپیما، اقدام به خرید می‌کنید، نه تنها هزینه بیشتری پرداخت نمی‌کنید، حتی ممکن است تخفیف هم بگیرید. ضمنا با خرید آنلاین بلیط هواپیما از پشتیبانی نیز برخودار هستید."
            }
            ,
            {
                id:5,
                question:"آیا پس از خرید اینترنتی بلیط هواپیما امکان استرداد آن وجود دارد؟ ",
                answer:
                "وقتی از علی‌بابا یعنی بهترین سایت خرید بلیط هواپیما ، بلیطتان را رزرو می‌کنید، خیالتان آسوده است که امکان استرداد وجه در صورت کنسل کردن بلیط وجود دارد. میزان جریمه را هم هنگام رزرو آنلاین بلیط هواپیما در قسمت قوانین استرداد بخوانید. میزان جریمه به نوع بلیط، کلاس پروازی، کلاس نرخی و... بستگی دارد."
            }
            ,
            {
                id:6,
                question:"آیا پس از خرید بلیط هواپیما، امکان تغییر نام یا نام خانوادگی وجود دارد؟ ",
                answer:
                "در پرواز داخلی یا خارجی، امکان تغییر نام و نام خانوادگی در بلیط سیستمی وجود ندارد. اما در بلیط چارتر، برخی از چارترکننده‌ها این تغییر را می‌پذیرند."
            }
            ,
            {
                id:7,
                question:"هنگامی که از سایت خرید بلیط هواپیما رزرو بلیط را انجام می‌دهیم، امکان انتخاب صندلی موردنظرمان وجود دارد؟ ",
                answer:
                "خیر؛ هنگام رزرو بلیط هواپیما داخلی یا خارجی امکان انتخاب صندلی وجود ندارد. البته در زمان چک‌این انتخاب محدوده صندلی امکان‌پذیر است."
            }
        ]

        export const  flightOutQuestion = [
            {
                id:1,
                question:"بلیط پرواز چه کشورها و ایرلاین‌هایی را می‌توانم‌ در سایت علی‌بابا جستجو و خریداری کنم؟ " ,
                answer:
                    "بلیط تمام خطوط هوایی دنیا در سایت علی‌بابا موجود است، چه پروازهایی که مبدا یا مقصد آنها ایران است و چه پروازهای داخلی دورترین کشورهای دنیا. پروازهای ایرلاین‌هایی مثل لوفت‌هانزا، امارات، قطرایرویز، ترکیش‌ایر، ایرفرانس، کی‌ال‌ام، آئروفلوت، آلیتالیا، اوکراینی، ایرایژیا، پگاسوس و ده‌ها ایرلاین دیگر در علی بابا قابل تهیه هستند. همچنین بلیط پروازهای خارجیِ شرکت های هواپیمایی داخلی مانند ماهان، ایران‌ایر، قشم ایر، آتا و .. نیز روی سایت علی‌بابا به فروش می‌رسد."
            },
            {
                id:2,
                question:"چطور می توانم در مورد مقررات پرواز یا ویزا مربوط به سفرم اطمینان پیدا کنم؟ " ,
                answer:
                    "حتما قبل از انتخاب پرواز خود در مورد مقررات پرواز و قوانین مربوط به ویزا تحقیق کنید (مثلا ممکن است مقصد سفر شما نیاز به ویزا نداشته باشد ولی برای توقفی که در مسیر دارد نیاز به ویزای ترانزیت داشته باشید). برای این کار به صفحه قوانین و مقررات پرواز خارجی مراجعه کنید و در صورتی که نیاز به اطلاعات بیشتری داشتید با پشتیبانی علی بابا تماس بگیرید."
            },
            {
                id:3,
                question:"آیا برای خرید بلیط ایرلاین‌های خارجی، نیازی به کردیت‌کارت یا روش‌های پرداخت ارزی خواهم داشت؟ " ,
                answer:
                    "به هیچ وجه. شما هزینه‌ بلیط را به صورت ریالی و با کارت‌های شتابی که در دست دارید، تنها با داشتن رمز دوم کارت پرداخت می کنید و بلیط شما بلافاصله صادر خواهد شد و قابل استفاده خواهد بود."
            },
            {
                id:4,
                question:"آیا ساعت، قیمت و دیگر مشخصات پروازها روی سایت علی‌بابا قطعی است؟ " ,
                answer:
                    "بله، آنچه پس از جستجوی پرواز مورد نظر خود روی سایت علی‌بابا می‌بینید، برنامه قطعی پروازهای ایرلاین‌هاست که به ریال محاسبه شده است. اگر احیانا تغییری در ساعت یا برنامه‌ی پرواز به وجود بیاید، از طریق پشتیبانی سایت علی‌بابا به اطلاع شما خواهد رسید."
            },
            {
                id:5,
                question:"آیا پروازهای چارتر خارجی هم روی سایت علی‌بابا عرضه می‌شود؟ " ,
                answer:
                    "بله. بلیط کلیه‌ی پروازهای چارتر خارجی که از سوی ایرلاین‌های داخلی یا خارجی برای فروش عرضه می‌شوند را می‌توانید روی سایت علی‌بابا ببینید."
            },
            {
                id:6,
                question:"چطور می توانم برای سفرم ارزان ترین بلیط ممکن را تهیه کنم؟ " ,
                answer:`ارزان بودن بلیط سفر به عوامل مختلفی مرتبط است که برخی از مهم ترین آنها این موارد هستند:
                در پروازهای سیستمی معمولا هرچه به زمان پرواز نزدیک تر می شویم به دلیل پر شدن کلاس نرخی های ارزان تر، قیمت آن افزایش پیدا می کند. معمولا هرچه زودتر پروازتان را بخرید ارزان تر است.
                بلیط ایرلاین های مختلف را چک کنید. برای اغلب مسیرها ایرلاین های کم هزینه (Low Cost Airline) وجود دارند که در ازای خدمات و امکانات کمتر، پروازهای ارزان تری به شما پیشنهاد می دهند.
                در روزهای مختلف سال، فصل و هفته و حتی ساعات متفاوت، قیمت یک پرواز ممکن است تغییرات زیادی داشته باشد. با استفاده از تقویم قیمتی و فیلترهای تعبیه شده جستجو می توانید با چند روز جابجایی پروازهای به مراتب ارزان تری پیدا کنید. علاوه بر این، پروازهای توقف دار و صبح زود هم معمولا پروازهای ارزان تری هستند.
                بلیط خود را از سایت های معتبر خریداری کنید و قیمت آنها را در ازای خدمتی که می دهند با هم مقایسه کنید.
                با در نظر گرفتن این موارد می توانید هوشمندانه، بهترین و ارزان ترین پرواز را برای سفر خود تهیه کنید.`
                },
            {
                id:7,
                question:"تقویم قیمتی (Flexible Date) چیست و چه کمکی به من می‌کند؟ " ,
                answer:
                    "تقویم قیمتی امکان مقایسه قیمت های روزهای نزدیک به جستجو را به شما می دهد. با کلیلک روی نوار سبز رنگ تقویم قیمتی، قیمت بلیط‌های ۳ روز قبل و ۳ روز بعد از تاریخ مورد نظر شما در جدولی نمایش داده می‌شود و به این ترتیب می‌توانید با تغییر کوچکی در برنامه‌ی سفر خود، هزینه‌ی بلیط را حتی تا نصف کاهش دهید!"
            },
            {
                id:8,
                question:"بهترین پروازها (Best Flights) چه پروازهایی هستند؟ " ,
                answer:
                    "در هر جستجویی که انجام می دهید، به صورت پیش فرض در ابتدای فهرست با پروازهایی روبرو می شوید که به عنوان بهترین پروازها به شما معرفی می شوند. در الگوریتم گزینش و نمایش این پروازها هر دو فاکتور قیمت و مدت زمان سفر در نظر گرفته شده است."
            },
            {
                id:9,
                question:"چگونه می توانم بلیط پروازم را کنسل کنم یا تغییر دهم و از شرایط و جریمه آن مطلع شوم؟ " ,
                answer:
                    "برای اطلاع دقیق از شرایط و جریمه کنسلی یا تغییر بلیط پرواز مورد نظرتان در هر ساعتی از شبانه روز می توانید با پشتیبانی علی‌بابا تماس بگیرید."
            },
            {
                id:10,
                question:"برای سوار شدن به هواپیما چه زمانی باید در فرودگاه باشم و چه مدارکی مورد نیاز است؟ " ,
                answer:
                    "برای اینکه بدون دغدغه سفر خود را آغاز کنید باید حداقل دو ساعت قبل از پرواز در فرودگاه حضور داشته باشید. برای پرواز نیازی به داشتن پرینت بلیط ندارید و تصویر و شماره بلیط به همراه مدارک شناسایی کفایت می کند."
            }
        ]
        export const  TrainQuestion = [
            {
                id:1,
                question:"در راه آهن و هنگام سوار شدن به قطار چه مدارکی لازم است؟ ",
                answer:
                `شما برای ورود به قطار باید این مدارک را با خود به همراه داشته باشید: پرینت بلیط و کارت شناسایی معتبر.
                در صورت داشتن تخفیف جانباز یا خانواده شهدا، به همراه داشتن کارت معتبر مربوطه نیاز ضروری است.`
            },
            {
                id:2,
                question:"مقدار بار مجاز در قطار چقدر است؟ ",
                answer:
                        "هر مسافر می‌تواند وسایل ضروری سفر خود را همراه ببرد به شرط آن‌كه حجم آن از ابعاد 75 سانتی متر و وزن 30 كیلوگرم تجاوز نكند. به عنوان مثال مسافر می‌تواند كیف‌دستی، بسته‌ و چمدان‌های كوچك محتوی لوازم شخصی، صندلی چرخ‌دار بیمار، كالسكه بچه و قفس كوچك پرندگان ریزجثه (حداكثر در ابعاد 40 سانتی‌متر) را به همراه داشته باشد."
            },
            {
                id:3,
                question:"روال استرداد یا کنسلی بلیط قطار چگونه است؟ ",
                answer:
                        `مسافر می‌تواند تا 60 دقیقه قبل از حرکت قطار، بلیط یا بلیط‌های خریداری‌شده را به صورت آنلاین استرداد کند.
                        برای استرداد بلیط قطار پس از زمان ذکرشده، مسافر باید تا قبل از حرکت قطار، و با ارایه بلیط چاپی و کارت شناسایی به صورت حضوری به یکی از مراکز فروش بلیط قطار مراجعه کند.`
            },
            {
                id:4,
                question:"قیمت بلیط برای کودک و نوزاد چگونه است؟ ",
                answer:
                        "قیمت بلیط کودک نیم‌بها و نوزاد 10 درصد مبلغ بزرگسال است."
            },
            {
                id:5,
                question:"چه زمانی باید در ایستگاه حضور داشته باشم؟ ",
                answer:
                        "حضور در ایستگاه یک ساعت قبل از حرکت قطار الزامی است. همچنین ده دقیقه مانده به حركت، تمام درهای قطار بسته خواهد شد و بعد از بسته‌شدن درها برای جلوگیری از خطرات احتمالی، سوارشدن به قطار امكان‌پذیر نیست."
            },
            {
                id:6,
                question:"در یک کوپه دربست چند نفر همراه اضافه می‌توان برد؟ ",
                answer:
                        `مسافر می‌تواند بعد از دربست‌کردن کوپه فقط یک نفر مسافر اضافی را بدون بلیط با این شرایط به همراه خود به قطار ببرد:
                        حق درخواست جا خارج از همان کوپه وجود ندارد؛
                        قبض این مسافر مطابق استحقاق او توسط رئیس قطار صادر می‌شود.
                        `
            },
            {
                id:7,
                question:"در صورت مفقودی بلیط قطار، چه باید کرد؟ ",
                answer:
                        `در صورت مفقودی بلیط، مسافر می‌تواند در زمان اداری به ایستگاه‌های راه‌آهن که سیستم آنلاین فروش بلیط دارند، مراجعه کند و دوباره بلیط را دریافت کند. همچنین به شرط حضور به‌موقع (حداكثر ۴۵ دقیقه مانده به حركت) در ایستگاه‌های راه‌آهن كه سیستم فروش بلیط آنلاین دارند و در وقت اداری، بلیط المثنی طبق آیین‌نامه‌ مربوط صادر می‌شود.
                        بلیط مفقودی باید از طریق شبكه‌ رایانه‌ای صادر شده و استرداد نشده باشد. صدور بلیط المثنی با ۵ درصد قیمت كل بلیط، انجام می‌شود و در صورت مفقود شدن آن، بلیط‌ المثنی دیگری صادر نخواهد شد. درحال حاضر بلیط المثنی از طریق سیستم استرداد نمی‌شود. (استرداد بلیط المثنی فقط به شرط ارائه‌ بلیط اصلی و بلیط المثنی به صورت همزمان در ایستگاه‌های آنلاین و كلیه‌ نمایندگی‌های فروش و با هماهنگی مركز یكپارچه فروش بلیط قطار انجام می‌شود).`
            },
            {
                id:8,
                question:"آیا این امکان وجود دارد که مسافر در پکیج قطار با هتل فدک درخواست اقامت بیشتر در هتل داشته باشد؟ در صورت امکان، وضعیت آن به چه صورتی است؟ ",
                answer:
                        `امکان اقامت بیشتر وجود دارد اما باید قبل از خرید با هتل مربوطه هماهنگ کرده باشند؛ همچنین تاریخ رفت و برگشت بلیط قطار باید بر اساس روزهایی باشد که در هتل می‌مانید. گفتنی است اقامت قطار فدک شامل شب اول و شب آخر می‌شود.`
            },
            {
                id:9,
                question:`
                آیا خانوم‌ها می‌توانند بلیط قطار را برای کوپه مخصوص بانوان بخرند؟ `,
                answer:
                        "بله این امکان وجود دارد. خانوم‌ها می‌توانند برای آرامش و راحتی خود در طول سفر، بلیط قطار را برای کوپه مخصوص بانوان بخرند. البته کوپه مخصوص آقایان هم برای آن‌ها درنظر گرفته شده است."
            },
            {
                id:10,
                question:`
                شرایط بیمه قطار چه گونه است؟ `,
                answer:
                        "تمام مسافران قطار از لحظه‌ ورود به ایستگاه مبدا تا خروج از ایستگاه مقصد در برابر حوادث بیمه هستند. بیمه‌ حوادث مسافری شامل جبران هزینه‌های پزشكی و همچنین جبران نقص عضو یا فوت ناشی از حوادثی مانندآتش سوزی، تصادف، انفجار، خارج شدن قطار از ریل، مانور، سنگ‌پرانی و سایر حوادث احتمالی می‌شود."
            }
        ]

        export const  BusQuestion = [
            {
                id:1,
                question:"آیا نیاز به خرید بلیط اتوبوس برای کودکان و اطفال زیر ۲ سال هم وجود دارد؟ ",
                answer:`بلیط اتوبوس افراد زیر دو سال در صورتی که صندلی به آن‌ها تعلق نگیرد رایگان است ولی در صورتی که نیاز به استفاده از صندلی داشته باشید، می‌بایست هزینه بلیط اتوبوس را کامل پرداخت نمایید.`            
            },
            {
                id:2,
                question:`
                امکان حمل حیوانات خانگی در داخل اتوبوس وجود دارد؟ `,
                answer:"طبق قوانین سازمان حمل‌ونقل امکان حمل حیوانات زنده در اتوبوس وجود ندارد."            
            },
            {
                id:3,
                question:"مدارک مورد نیاز برای استفاده از اتوبوس چیست؟ ",
                answer:"به همراه داشتن کارت شناسایی معتبر (کارت ملی یا شناسنامه) برای دریافت بلیط الزامی است."            
            },
            {
                id:4,
                question:`
                آیا برای استفاده از اتوبوس نیاز به پرینت بلیط است؟ `,
                answer:"برای استفاده از بلیط‌ اتوبوس، چاپ بلیط در دفتر تعاونی مربوطه با ارائه پیامک شماره بلیط و کارت شناسایی معتبر الزامی است."            
            },
            {
                id:5,
                question:"جهت سوار شدن به اتوبوس چه مدت قبل از حرکت در ترمینال حضور داشته باشیم؟ ",
                answer:"در صورتی که حرکت سرویس در ساعت مقرر انجام گردد مسافر می بایست حداکثر 30 دقیقه قبل حرکت سرویس در ترمینال مبدا حضور داشته باشد."            
            },
            {
                id:6,
                question:"چگونه می‌توانم بلیط اتوبوسم را استرداد کنم؟ ",
                answer:`در صورت قابل استرداد بودن بلیط خریداری شده، در «پنل کاربری» از منوی «سفارشات و استردادها»، سفارش مورد نظر را انتخاب کنید؛ بعد از کلیک بر روی گزینه استرداد و تکمیل مراحل، بلیط مورد نظر طبق قوانین و مقررات استرداد می‌شود.
                هزینه‌ای که مسترد می‌شود به همان شماره حسابی واریز می‌شود که خرید انجام شده است. اگر لازم است که هزینه مسترد شده به حساب دیگری واریز گردد، باید با پشتیبانی تماس گرفته و آن‌ها را در جریان بگذارید.`            
            },
            {
                id:7,
                question:"میزان بار مجاز هر مسافر در سفر با اتوبوس چقدر است؟ ",
                answer:`طبق قوانین سازمان حمل‌ونقل میزان بار مجاز 20 کیلوگرم است. البته برخی از تعاونی‌ها با دریافت هزینه، امکان حمل بار تا 40 کیلوگرم را نیز ارائه می‌دهند. همچنین یکی دیگر از مسائلی که در این زمینه باید مد نظر قرار بدهید، تعاونی اتوبوس شماست.
                معمولا تعاونی ها، علاوه بر قوانین کلی میزان بار مجاز، قوانین خاص خودشان را دارند که در بعضی موارد، با قوانین تعاونی های دیگر فرق می‌کند. برای این که از میزان بار مجازتان مطمئن شوید و در حین سفر به مشکل برنخورید، به تعاونی که از آن بلیط تهیه کرده‌اید زنگ زده و از آن‌ها سوال کنید.
                به این موضوع هم دقت کنید که اگر میزان بار اضافه شما بیش از حد باشد، متصدی اتوبوس ممکن است از گذاشتن آن‌ها در اتوبوس ممانعت کند. در این نوع مواقع می‌توانید در این مورد صحبت کنید که هزینه میزان بار اضافه‌تان را پرداخت کنید تا بتوانید همه وسیله‌هایتان را با خودتان حمل کنید.`            
            }
        
        ]

        export const  HotelQuestion = [
            {
                id:1,
                question:"پیش از رزرو هتل چه طور درباره آن و فرآیند رزرو اطلاعات به دست بیاوریم؟ ",
                answer:"فرایند انتخاب و رزرو اینترنتی هتل در علی بابا بسیار ساده است. به سادگی و با چند کلیک می توانید با انتخاب مقصد و تاریخ سفر خود، هتل مناسب خود را با قیمت مناسب رزرو کنید. با این حال در صورت نیاز، تیم پشتیبانی علی بابا 24 ساعته پاسخگوی شماست."
            },
            {
                id:2,
                question:"هزینه هتل خارجی را چه طور بپردازیم؟ با کارت‌های شتاب این فرآیند امکان‌پذیر است؟ ",
                answer:"زمانی که برای رزرو هتل خارجی به علی بابا مراجعه می‌کنید، خیالتان از هر بابت به خصوص پرداخت راحت باشد. شما می‌توانید هزینه رزرو هتل را با همین کارت‌های شتاب ساده خودتان بپردازید. به هیچ وجه نیازی به استفاده از کارت‌های اعتباری خارجی نیست."
            },
            {
                id:3,
                question:`
                آیا پس از اینکه هتل را رزرو کردیم، می‌توانیم رزرومان را کنسل کنیم و پولمان را پس بگیریم؟ `,
                answer:`طبیعی است که گاهی اوقات سفرمان به هر دلیلی کنسل شود. در این میان هتل‌ها قوانین خودشان را برای کنسلی دارند. بعضی از هتل‌ها استرداد پول را می‌پذیرند، البته این استرداد در بیشتر موارد با کسر هزینه جریمه است. میزان جریمه هم باز به قوانین هتل و زمانی که کنسلی را اعلام می‌کنید، بستگی دارد. (هر چه دیرتر کنسلی را اعلام کنید، احتمال افزایش جریمه بیشتر است).
                اما هتل‌هایی هم وجود دارند که کنسلی و استرداد وجه را نمی‌پذیرند. زمانی که در علی بابا در حال رزرو آنلاین هتل هستید، موضوع قوانین کنسلی را مورد توجه قرار دهید. در هنگام رزرو در مقابل هر یک از اتاق‌های هتل واژه‌های «قوانین کنسلی» یا «غیرقابل استرداد» را مشاهده می‌کنید. غیرقابل استراداد همان طور که از نامش پیداست، وجهی به شما پس نمی‌دهد. اما اگر واژه قوانین کنسلی را دیدید، روی آن کلیک کنید و این قوانین را بخوانید.`
            },
            {
                id:4,
                question:"در چه ساعتی می‌توانیم در هتل اتاق‌مان را تحویل بگیریم و در چه ساعتی باید اتاق را پس دهیم؟ ",
                answer:"عموما ورود مسافر به اتاق (چک‌این) در ساعت 14 و خروج مسافر (چک‌اوت) ساعت 12 ظهر است."
            },
            {
                id:5,
                question:"نیم‌شارژ ورود و خروج چیست؟",
                answer:"ساعت ورود به هتل ساعت 14 و خروج 12 ظهر است؛ مسافر انی که ورود زود هنگام (حدود ساعت 8 صبح) یا خروج دیر هنگام (حدود ساعت 18 عصر) را دارند، از این گزینه استفاده می‌کنند؛ قیمت نیم‌شارژ معمولا نصف رزرو یک شب است."
            },
            {
                id:6,
                question:`
                کودکان تا چه سنی رایگان پذیرش می‌شوند و تخت آنها چگونه است؟ `,
                answer:"شرایط سنی کودک برای پذیرش در هتل در قسمت قوانین اطلاع رسانی شده است."
            },
            {
                id:7,
                question:`
                تفاوت اتاق‌ها با هم مانند دبل یا توئین بودن یا جونیور یا امپریال یا حتی سوئیت چیست؟ `,
                answer:"اتاق دبل دو تا تخت چسبیده به هم دارند و مناسب زوج‌ها هستند؛ و اتاق‌های تویین دو تخت سینگل یا جدا از هم دارند. اتاق‌هایی مثل جونیور یا امپریال از نظر متراژ دیزاین و طبقات اتاق‌های بهتری هستند نسبت به اتاق های استاندارد. البته سرویس و خدمات هتل برای همه اتاق‌ها یکسان است."
            },
            {
                id:8,
                question:"واچر چیست؟ ",
                answer:"رسید پرداخت و تاییدیه رزرو اقامتگاه را «واچر» می‌گویند. واچر پس از پرداخت از سوی سیستم رزرواسیون علی‌بابا صادر می‌شود و در اختیار رزرو‌کننده در پروفایل کاربری ایشان قرار خواهد گرفت."
            },
            {
                id:9,
                question:`
                دلیل تفاوت نرخ شما با هتل چیست و چرا باید به شما اعتماد کنیم؟ `,
                answer:"به دلیل اینکه ما به طور سالیانه قرار داد داریم، در ایام غیر پیک مسافرهای هتل را تامین می‌کنیم، مسافر های گروهی برای هتل می‌فرستیم و سایت ما بالاترین بازدیدکننده و رزرو کننده را در کشور دارد."
            },
            {
                id:10,
                question:"مبلغ درج شده در سایت شما مبلغ نهایی است؟ آیا امکان دارد بعدا تغییر یابد و باید کل مبلغ در ابتدا پرداخت شود؟ ",
                answer:"مبلغ نهایی است مگر اینکه در زمان‌های خاص مانند عید نوروز باشیم؛ در این شرایط حتما در هنگام رزرو ذکر خواهیم کرد که نرخ فعلی علی‌الحساب است."
            }      
        ]